import styled from 'styled-components'
import { Typography, Grid } from '@material-ui/core'
import { px2rem } from '../../../../../theme/Global'

export const CompanySettingsConfirmationModalMessage = styled(Typography)`
  font-weight: 600;
  font-size: ${px2rem(16)}rem;
  text-align: left;
  margin-bottom: 2rem;
`

export const CompanySettingsModalGridContainer = styled(Grid)`
  padding: 2rem 1.5rem;
`
